import { Outlet, useLocation } from "react-router-dom";
import AppInternetReconnectingBox from "../../socket/appComponents/UtilsComponents/AppInternetReconnectingBox";
import SocketSessionInfoModel from "../../socket/appComponents/UtilsComponents/SocketSessionInfoModel";
import { SocketContextProvider } from "../../socket/hooks/socket-context";
import LeftMenu from "../Menu/LeftMenu";
import TopMenu from "../Menu/TopMenu";
import ExpireSubscription from "../Subscription/Expired/ExpireSubscription";

import {
  ContentWrap,
  HomeLayoutWrap,
  HomeLayoutWrapLeft,
  HomeLayoutWrapRight,
} from "./ClientLayout";
import { useAppSelector } from "../../Store";
import { useAuthStore } from "../../Store/Slices/AuthSlice";
import { isEmptyObject } from "../../Utils";
import { Suspense, useEffect, useState } from "react";
import LinearLoader from "../../AppComponents/Loader/LinearLoader";
import NotificationBar from "../Menu/notification-bar";
import SupportChatWidget from "../support-chat-widget";
import { MMLitePopup } from "../Welcome/MMLitePopup/MMLitePopup";
import { useMMLiteEnablement } from "../../socket/hooks/useMMLiteEnablement";

const ProtectedLayout = () => {
  const { userConfig } = useAppSelector(useAuthStore);
  const location = useLocation();
  
  // MMLITE popup state and logic - moved hooks to top
  const [showMMLitePopup, setShowMMLitePopup] = useState(false);
  const [mmliteDismissed, setMMLiteDismissed] = useState(false);
  const mmliteEnabled = useMMLiteEnablement();
  
  const permissionsData: any = userConfig?.payload?.allowed_permissions ?? null;

  useEffect(() => {
    // Only show MMLitePopup on home page ('/') route for logged in users
    if (
      window.location.pathname === "/" &&
      !mmliteEnabled &&
      !mmliteDismissed &&
      localStorage.getItem("ws_id") === 'www_example_com_X5o5oKob'
    ) {
      setShowMMLitePopup(true);
    }
  }, [window.location.pathname, mmliteEnabled, mmliteDismissed]);

  if (
    !userConfig?.payload ||
    (window.localStorage.getItem("expiry_time") &&
      userConfig?.payload &&
      isEmptyObject(permissionsData))
  )
    return null;

  const handleEnableMMLite = () => {
    // TODO: Call API to enable MMLITE, update store
    setShowMMLitePopup(false);
    // Optionally, update mmliteEnabled state via store
  };

  const handleDismissMMLite = () => {
    setShowMMLitePopup(false);
    setMMLiteDismissed(true);
  };
  return (
    <SocketContextProvider>
      <AppInternetReconnectingBox />
      <HomeLayoutWrap>
        <SocketSessionInfoModel />
        <HomeLayoutWrapLeft>
          <LeftMenu />
        </HomeLayoutWrapLeft>
        <HomeLayoutWrapRight>
          <TopMenu />
          {/* MMLITE Enablement Pop-up - only show on home page */}
          {window.location.pathname === "/" && showMMLitePopup && (
            <MMLitePopup
              open={showMMLitePopup}
              onClose={handleDismissMMLite}
              onSkip={handleDismissMMLite}
            />
          )}
          {userConfig?.payload?.subscription_active ||
          location?.pathname?.includes("subscription-plans/plans") ||
          location?.pathname?.includes("subscription/success") ? (
            <ContentWrap id="main-section">
              <NotificationBar />
              <Suspense fallback={<LinearLoader />}>
                <Outlet />
              </Suspense>
              <SupportChatWidget />
            </ContentWrap>
          ) : (
            <ExpireSubscription />
          )}
        </HomeLayoutWrapRight>
      </HomeLayoutWrap>
    </SocketContextProvider>
  );
};

export default ProtectedLayout;
